import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import { useGift } from '@/hooks/purchase';
import GiftIcon from 'icons/gift-icon.svg';

import GiftCardHeader from './GiftCardHeader';
import messages from './messages';
import Premium from './Premium';
import RedeemFlow from './RedeemFlow';
import * as Styled from './styles';

const RedeemHeroContent = styled.div`
	width: 90%;
	${minWidth('desktop')} {
		width: 70%;
	}
	${minWidth('desktopLarge')} {
		width: 60%;
	}
`;

const RedeemHeroHeading = styled.div`
	${fontSize(FontSizes['3xl'])};
	${fontWeight(FontWeights.Light)};
	text-align: center;
	line-height: 1.5;
	margin-bottom: 0.55rem;
	${minWidth('desktop')} {
		margin-bottom: 0.5rem;
	}
`;

const Redeem = () => {
	const { formatMessage } = useIntl();
	const gift = useGift();

	return (
		<>
			<GiftCardHeader isRedeem />
			<Styled.GiftCardHeroWrapper>
				<Styled.FullscreenBackgroundDesktop
					src="/_n/images/gift-card/background-giftcard.webp"
					objectPosition="center center"
				/>
				<Styled.Grid>
					<Styled.HolidayUpsell>
						<Styled.FullscreenBackgroundMobile
							src="/_n/images/gift-card/background-giftcard-tablet.webp"
							objectPosition="center top"
						/>
						<RedeemHeroContent>
							<Styled.IconWrapper>
								<GiftIcon />
							</Styled.IconWrapper>
							<RedeemHeroHeading>
								{formatMessage(gift.hasRedeemed ? messages.redeemedTitle : messages.redeemTitle)}
							</RedeemHeroHeading>
						</RedeemHeroContent>
					</Styled.HolidayUpsell>
					<Styled.HolidayFormContainer id={MAIN_CONTENT_ID}>
						<RedeemFlow gift={gift} />
					</Styled.HolidayFormContainer>
				</Styled.Grid>
			</Styled.GiftCardHeroWrapper>
			<Premium />
		</>
	);
};

export default Redeem;
